import { render, staticRenderFns } from "./AudioControl.vue?vue&type=template&id=515126e4&"
import script from "./AudioControl.vue?vue&type=script&lang=js&"
export * from "./AudioControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports